<template>
  <div class="flex gap-2 items-center justify-between pt-0 pb-2 xl:px-4 lg:px-4 md:px-4 sm:px-2 xs:px-0 bg-transparent">
    <div class="flex-1">
      <div  class="min-w-[17.5rem] max-w-[17.5rem]">
        <SelectChatbot
          :isShowDropdownIcon="false"
          :disabled="gConversationData.conversationMessageList.length > 0"
          :isClearable="false"
          :valueKey="
            gConversationData.isDeleted
              ? gConversationData.model.name
              : gConversationData.modelActiveName
          "
          :options="cData.modelOptionList"
          :onChange="onChangeModelSelect"
          :label="$t('home.selectChatbot')"
        />
          <!-- :valueKey="
            gConversationData.isDeleted
              ? gConversationData.model.name
              : gConversationData.modelActiveName
          " -->
      </div>
    </div>
    <div class="flex relative justify-end items-center gap-6 h-10">
      <div class="flex gap-2 items-center xs:hidden sm:hidden md:hidden">
        <span class="text-right  text-[#330066]">
          {{ gUserAuthData.username }}
        </span>
        <div
          class="w-[32px] h-[32px] flex items-center justify-center cursor-pointer"
          @click="logout"
        >
          <img
            src="/images/icons/ic-arrow-right-on-rectangle-area-outline-purple.png"
            class="max-w-5"
            alt="logout"
          />
        </div>
      </div>
      <div
        class="relative pointer-events-none xs:cursor-pointer xs:pointer-events-auto sm:cursor-pointer sm:pointer-events-auto md:cursor-pointer md:pointer-events-auto"
        @click="onClickAvatar"
      >
        <img
          class="min-w-[32px] min-h-[32px] max-w-[32px] max-h-[32px] rounded-full object-cover"
          :src="
            gUserAuthData.avatarFile?.url ||
            '/images/contents/avatar-default.png'
          "
          alt="Icon"
        />

        <div
          v-if="cData.isShowDialog"
          class="bg-white p-4 rounded-2xl absolute z-20 right-1 top-10 flex gap-2 items-center shadow-md"
          @click="logout"
        >
          <span class="text-right font-medium text-[#9457EB]">
            {{ gUserAuthData.username }}
          </span>
          <div
            class="w-[32px] h-[32px] flex items-center justify-center cursor-pointer"
          >
            <img
              src="/images/icons/ic-arrow-right-on-rectangle-area-outline-purple.png"
              class="max-w-5"
              alt="logout"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const componentName = 'CustomTopbar';
import { useNuxtApp } from '#app';
import { ModelConversationDetail } from '~/services/conversation/dto/conversation.detail.dto';
import { ModelGETPresetAssociationPreset } from '~/services/preset-asso/dto/preset-asso.dto';

const { $_, $services, $functions } = useNuxtApp();
import { LOCAL_STORAGE } from '~/plugins/constants/localStorage';
import {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
} from '~/plugins/functions/localStorage';
const gConversationData = useConversationData();
const gServiceData = useServiceData();
const gUserAuthData = useUserAuthData();
const gPresetData = usePresetData();
const gIsLimit = useIsLimit();
const gLimitMessage = useLimitMessage();

const cData = reactive({
  isShowDialog: false,
  presetOptionList: [],
  modelOptionList: [],
});

defineProps({
  onChangePresetSelect: {
    type: Function,
    default: null,
  },
});

onMounted(() => {
  getPresetList();
  getModelList();
  getUserData();
  gServiceData.value.getPresetList = getPresetList;
  gServiceData.value.getModelList = getModelList;
});

const getPresetList = async () => {
  const params = {
    orderType: 'desc',
    orderBy: 'createdAt',
    ignorePage: 'true',
  };
  const presetAssoService = $services.presetAssoController();
  const presetList = await presetAssoService.getPresetAssociationPresetActive(
    params
  );
  const workflowService = $services.workflowController();
  const workflowList = await workflowService.getWorkflowRuntime(params);

  cData.presetOptionList = [
    {
      isGroup: true,
      text: '--- Workflow ---',
    },
    ...workflowList.map((e) => {
      return {
        text: e.className || `workflow_${e.id}`,
        value: `workflow_${e.id}`,
        data: e,
      };
    }),
    {
      isGroup: true,
      text: '--- Preset ---',
    },
    ...presetList.map((e) => {
      return {
        text: e.name,
        value: e.id.toString(),
        data: e,
      };
    }),
  ];
};

const onChangePresetSelect = async (value) => {
  gConversationData.value.presetActiveId = value;
  const presetSelected = cData.presetOptionList?.filter(
    (e) => e.value === value
  )[0];
  console.log('onChangePresetSelect', presetSelected);
  if (presetSelected) {
    if (presetSelected.data.type === 'workflow') {
      gConversationData.value = new ModelConversationDetail({
        workflowActiveId: presetSelected.data.id,
        presetActiveId: value,
      });
    }
    
    gConversationData.value.presetId = presetSelected.data.presetId;
    gPresetData.value = await getPresetDetail();
    gConversationData.value.isPresetSelected = true;
  }
};

const getPresetDetail = async () => {
  const params = gConversationData.value.presetId;
  if (params) {
    const presetAssoService = $services.presetAssoController();
    const data = await presetAssoService.getPresetAssociationPreset(params);

    if (data.avatarFilePath) {
      const presetService = $services.presetController();
      data.avatarFile.url = URL.createObjectURL(
        await presetService.getPresetFile(data.avatarFilePath)
      );
    }
    console.log('getPresetDetail', data);
    return data;
  } else {
    return new ModelGETPresetAssociationPreset();
  }
};

const getUserData = async () => {
  const accessToken = getLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
  const { userId } = $functions.decodeToken(accessToken);

  const jwtService = $services.jwtController();
  const data = await jwtService.getUserDetail(userId);

  if (data.avatarFilePath) {
    const presetService = $services.presetController();
    const avatarBlob = await presetService.getPresetFile(data.avatarFilePath);
    data.avatarFile.url = URL.createObjectURL(avatarBlob);
  }
  // setLocalStorage(LOCAL_STORAGE.USER_AUTH, data);
  gUserAuthData.value = data;
  // }
};

// Model
const getModelList = async () => {
  const modelService = $services.modelController();
  const modelList = await modelService.getModel({
    orderBy: 'createdAt',
    orderType: 'desc',
    ignorePage: 'true',
  });

  cData.modelOptionList = modelList.map((e) => {
    return {
      text: e.name,
      value: e.value,
      data: e,
    };
  });
};

const onChangeModelSelect = async (value) => {
  gConversationData.value.modelActiveId = value;
  const modelSelected = cData.modelOptionList?.filter(
    (e) => e.value === value
  )[0];
  if (modelSelected) {
    gConversationData.value.modelActiveName = modelSelected.data.value;
    gConversationData.value.model = modelSelected.data.value;
    gConversationData.value.isModelSelected = true;

    await handleCheckQuota();
  }
  
};

const handleCheckQuota = async () => {
  const params = {
    // presetVersionKey: gPresetData.value.versionKey,
    userId: gUserAuthData.value.id,
    model: gConversationData.value.modelActiveName,
  };
  const quotaService = $services.quotaController();
  const data = await quotaService.checkQuota(params);
  if (data.quotaWarning) {
    $functions.notify.info({ text: data.quotaWarning });
    gLimitMessage.value = data.quotaWarning;
    if (data.isLimit) {
      gIsLimit.value = true;
    }
  }else {
    gIsLimit.value = false;
  }
};

const logout = async() => {
  await handleLogout();
};

const handleLogout = async () => {
  const jwtService = $services.jwtController();
  const isLoggedOut = await jwtService.logout();
  if(isLoggedOut) {
    removeLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
    window.location.reload();
  }

}

const onClickAvatar = async () => {
  cData.isShowDialog = !cData.isShowDialog;
};
</script>

<style lang="scss" scoped></style>
